import React from "react"
import Layout from "../../components/layout"
import SEO from "../../components/seo"
import BannerInterior from '../../components/BannerInterior'
import { SimpleImg } from 'react-simple-img'
import ServicioIconBlock from '../../components/ServicioIconBlock'
import { FormattedMessage, injectIntl } from "gatsby-plugin-intl"

import soluciones_side from '../../images/aereo-side-thumb.jpg'
import flechitasmarco from '../../images/flechitas-marco.svg'
import bannerimg from '../../images/banner-aereo.jpg'
import iconbanner from '../../images/icon-na-aereo.svg'

import ta1 from '../../images/icon-aereo-2.svg'
import ta2 from '../../images/icon-aereo-4.svg'
import ta3 from '../../images/icon-aereo-5.svg'
import ta4 from '../../images/icon-aereo-6.svg'
import ta5 from '../../images/icon-aereo-7.svg'

import FormaServicios from '../../components/FormaServicios'

const Aerea = ({intl}) => (
  	<Layout>

		<SEO
			title={intl.formatMessage({ id: "header.aerea" })}
			description={intl.formatMessage({ id: "aerea.subtitulo" })}
		/>

		<BannerInterior titulo={intl.formatMessage({ id: "aerea.titulo" })} imgsrc={bannerimg}/>

		<section className="soluciones-block">
			<div className="block block-1">
				<div className="cont">
					<div className="soluciones-heading">
						<header>
							<div className="icon">
								<img src={iconbanner} alt="Transportación aérea" width="40" height="40"/>
							</div>
							<h2><FormattedMessage id="aerea.heading" /></h2>
						</header>
					</div>
					<div className="row mt-5">
						<div className="col-md-12 col-lg-7">
							<article>
								<p className="lead"><FormattedMessage id="aerea.subtitulo" /></p>
								<p><FormattedMessage id="aerea.descripcion" /></p>
							</article>
						</div>
						<div className="col-lg-5">
							<div className="soluciones-marco d-none d-lg-block">
								<SimpleImg src={soluciones_side} alt="Barco" width={365} height={449} placeholder={false} className="img" />
								<span className="marco">
									<img src={flechitasmarco} alt="marco"/>
								</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div className="block block-2" style={{ marginBottom: `100px` }}>
				<div className="cont">
					<div className="row justify-content-center aereo-blocks">
						<div className="col-12 col-sm-6 col-md-6 col-lg-4">
							<ServicioIconBlock
								imgsrc={ta1}
								titulo={intl.formatMessage({ id: "aerea.extra1" })}
								descripcion={intl.formatMessage({ id: "aerea.extra1desc" })}
							/>
						</div>
						<div className="col-12 col-sm-6 col-md-6 col-lg-4">
							<ServicioIconBlock
								imgsrc={ta2}
								titulo={intl.formatMessage({ id: "aerea.extra2" })}
								descripcion={intl.formatMessage({ id: "aerea.extra2desc" })}
							/>
						</div>
						<div className="col-12 col-sm-6 col-md-6 col-lg-4">
							<ServicioIconBlock
								imgsrc={ta3}
								titulo={intl.formatMessage({ id: "aerea.extra3" })}
								descripcion={intl.formatMessage({ id: "aerea.extra3desc" })}
							/>
						</div>
						<div className="col-12 col-sm-6 col-md-6 col-lg-4">
							<ServicioIconBlock
								imgsrc={ta4}
								titulo={intl.formatMessage({ id: "aerea.extra4" })}
								descripcion={intl.formatMessage({ id: "aerea.extra4desc" })}
							/>
						</div>
						<div className="col-12 col-sm-6 col-md-6 col-lg-4">
							<ServicioIconBlock
								imgsrc={ta5}
								titulo={intl.formatMessage({ id: "aerea.extra5" })}
								descripcion={intl.formatMessage({ id: "aerea.extra5desc" })}
							/>
						</div>
					</div>
				</div>
			</div>

			<div className="block block-3">
				<div className="cont">
					<div className="formulario">
						<p className="mb-5"><FormattedMessage id="contacto.descripcion" /></p>
						<FormaServicios/>
					</div>
				</div>
			</div>
		</section>

	</Layout>
)

export default injectIntl(Aerea)
